import http, { getAuthConfig } from './http';

const createApiCall = (endpoint) => async () => {
  try {
    const response = await http.get(endpoint, getAuthConfig());
    return { payload: response.data.payload, error: null };
  } catch (error) {
    return { payload: null, error };
  }
};

export const SERVICE_CLIENT = {
  getClientData: createApiCall('/home/site_setting'),
  getSocialMedia: createApiCall('/social-media'),
  getPrivacyPolicy: createApiCall('/privacy-policy'),
  getTermsAndCondition: createApiCall('/term-condition'),
};
